import '../css/Content.css'
import kitties from '../images/cornerkitty.png'

const bio = `Liz is a Brooklyn, NY based artist who works in comics, games, tv and film.`

export default function Landing() {
    return (
      <div className="landing-box">
        <div className='intro-container'>
            <p>{bio}</p>
        </div>
        <div className='landing-right-image-container'>
          <img key='kitties' src={kitties} alt='kitties' id="landingImage-small" />
        </div>
      </div>
    )
}